import { debounce } from 'lodash-es';
import SyosEvents from './utils/SyosEvents';
import { templatePricetypeSelectionPopup } from './templates/templates';
import SyosUiContainer from './SyosUiContainer';
import { EventHandler } from '../utils/dom-events';
import GestureHelper from './utils/GestureHelper';
import { clamp } from './utils/math';
import syosMediaQuery from './utils/syosMediaQuery';

const CLASS_CONTAINER = 'tn-syos-price-type-selector__content-container';
const CLASS_DISMISS = 'tn-syos-price-type-selector__dismiss';

const HTML = `
  <div class="tn-syos-mobile-overlay__scroll-content-wrapper">
    <div class="${CLASS_CONTAINER}"></div>
  </div>
`;

const MARGIN = 10;

class SyosPriceTypeSelector extends SyosUiContainer {

  constructor(syosController) {
    super(syosController, '.tn-syos-price-type-selector');

    this.bindMethods();
    this.seat = null;
    this.pricetypeButtons = null;

    this.$el.hide();
    this.$el.html(HTML);

    this.$container = this.find(`.${CLASS_CONTAINER}`);

    this.gesture = new GestureHelper(document.body, {
      onPress: this.onPress,
      onPanMove: this.onPanMove,
      onClick: this.onClick,
      // debugId: 'SyosPriceTypeSelector',
    });

    this.windowResizeHandler = new EventHandler(window, 'resize', debounce(this.onWindowResize, 5));

    this.syosController.on(SyosEvents.SEAT_CLICK, this.onSeatClick);
    this.syosController.on(SyosEvents.SCREEN_UPDATED, () => this.hide());
  }

  bindMethods() {
    this.onSeatClick = this.onSeatClick.bind(this);
    this.onPress = this.onPress.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onPanMove = this.onPanMove.bind(this);
    this.hide = this.hide.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
  }

  onWindowResize() {
    if (syosMediaQuery.testIsMobile() === false) {
      this.hide();
    }
  }

  onPress(event) {
    this.pressOriginatedInPopover = this.testEventOccuredInPopover(event);
  }

  onSeatClick({ seat }) {
    if (seat === this.seat) {
      return;
    }

    this.seat = seat;
    this.seat.setIsViewingInPriceTypeSelector(true);

    const data = this.seat.getTemplateData();
    const html = templatePricetypeSelectionPopup.render(data);

    this.$container.html(html);

    this.pricetypeButtons = this.$container.find('[data-price-type-id]').toArray();
    this.btnClose = this.$container.find(`.${CLASS_DISMISS}`)[0];

    this.show();
  }

  onPanMove() {
    if (syosMediaQuery.testIsMobile()) {
      return;
    }

    if (this.pressOriginatedInPopover === false) {
      this.hide();
    }
  }

  testEventOccuredInPopover(event) {
    return this.$container[0].contains(event.target);
  }

  testEventOccuredInViewingSeat(event) {
    if (this.seat !== null) {
      return this.seat.testContainsElement(event.target);
    }
    return false;
  }


  onClick(event) {
    const clickedInPopover = this.testEventOccuredInPopover(event);

    if (clickedInPopover) {
      const button = this.pricetypeButtons.find(el => el.contains(event.target));

      if (button) {
        const priceTypeId = parseInt(button.dataset.priceTypeId, 10);
        this.seat.selectPriceType(priceTypeId);
        this.hide(event);
      } else {
        if (this.btnClose.contains(event.target)) {
          this.hide(event);
        }
      }
    } else {
      if (this.testEventOccuredInViewingSeat(event) === false) {
        this.hide(event);
      }
    }
  }

  show() {
    const doShow = () => {
      this.$el.show();
      this.$el[0].scrollTop = 0;
      window.setTimeout(() => {
        this.gesture.start();
      });
    };

    this.windowResizeHandler.start();

    if (syosMediaQuery.testIsMobile()) {
      doShow();
      return;
    }

    const { clientWidth: viewportWidth } = document.documentElement;

    this.$el.show();
    const seatRect = this.seat.getClientRect();
    const popoverRect = this.$container[0].getBoundingClientRect();
    this.$el.hide();

    const minPopoverX = MARGIN;
    const minPopoverY = MARGIN;
    const maxPopoverX = viewportWidth - popoverRect.width - MARGIN;
    const maxPopoverY = Infinity;

    const x = clamp(
      (seatRect.left + (seatRect.width * 0.5)) - (popoverRect.width * 0.5),
      minPopoverX,
      maxPopoverX,
    );

    const y = clamp(
      seatRect.top - popoverRect.height - MARGIN,
      minPopoverY,
      maxPopoverY,
    );

    window.requestAnimationFrame(() => {
      this.$container.css({
        left: `${Math.round(x)}px`,
        top: `${Math.round(y)}px`,
      });
      doShow();
    });
  }

  hide(event) {
    if (event) {
      event.preventDefault();
    }

    this.gesture.stop();
    this.windowResizeHandler.stop();

    if (this.seat !== null) {
      this.seat.setIsViewingInPriceTypeSelector(false);
      this.seat = null;
    }

    window.setTimeout(() => {
      this.$el.hide();
    });
  }
}

export default SyosPriceTypeSelector;



// WEBPACK FOOTER //
// ./V7/syos/SyosPriceTypeSelector.js